export default {
  label: {
    ok: 'ठीक है',
    confirm: 'कन्फर्म करें',
    cancel: 'कैंसिल करें',
    download: 'डाउनलोड',
    submit: 'सबमिट करें',
    search: 'सर्च',
    recharge: 'रिचार्ज',
    balance: 'बैलेंस',
  },
  tip: {
    success: 'सफल',
  },
  text: {},
  defaultPage: {
    noMore: 'और डेटा नहीं है',
  },
  home: {
    scratchOff: 'स्क्रैच ऑफ',
    copied: 'सफलतापूर्वक कॉपी किया गया, कृपया दोस्तों के साथ शेयर करें',
    tip: {
      beforDownload: 'कृपया रजिस्ट्रेशन या लॉगिन करें',
    },
  },
  alert: {
    logout: 'लॉग आउट',
    sureLogout: 'क्या आप वाकई लॉगआउट करना चाहते हैं?',
  },
  warning: {
    unopen: 'अभी तक चालू नहीं किया गया है',
  },
  notification: {
    title: 'नोटिफिकेशन',
    announcements: 'घोषणाएँ',
    systemMessage: 'सिस्टम संदेश',
  },
  vip: {
    currentLevel: 'वर्तमान लेवल',
    collected: 'इकट्ठा करने के लिए',
    finished: 'समाप्त करने के लिए',
    received: 'प्राप्त किया',
    recharge: 'रिचार्ज',
    move: 'अगले लेवल तक पहुंचने के लिए बहुत कुछ',
    title: 'वीआईपी',
    table: {
      level: 'वीआईपी लेवल',
      reward: 'रिवॉर्ड',
      bouns: 'बोनस',
      spin: 'स्पिन',
    },
    label: {
      reward: 'VIP लेवल रिवार्ड',
      weekCard: 'वीकली कार्ड',
      weekReward: ' साप्ताहिक VIP रिवार्ड',
      withdrawAmount: 'निकासी राशि',
      withdrawTimes: 'निकासी समय',
      withdrawFee: 'निकासी शुल्क',
      silverWeekCard: 'सिल्वर वीकली कार्ड',
      goldWeekCard: 'गोल्ड वीकली कार्ड',
      diamondWeekCard: 'डायमंड वीकली कार्ड',
      day: 'दिन',
      rewardDetails: 'पुरस्कार विवरण',
      rewardAccumulation: 'पुरस्कार संचय',
      vipUpgrade: 'VIP अपग्रेड',
      buyWeekCard: 'साप्ताहिक कार्ड खरीद अधिकार',
      weekCardRecharge: 'साप्ताहिक कार्ड रिचार्ज',
      weekCardBuyRecord: 'साप्ताहिक कार्ड खरीद रिकॉर्ड',
    },
    tip: {
      levelDetail: {
        t01: 'VIP लेवल रिवार्ड',
        p1: 'VIP लेवल <0>{{level}}</0> तक पहुंचने पर एक बार मिलने वाला स्पेशल रिवार्ड:',
        t02: 'साप्ताहिक VIP रिवार्ड',
        p2: 'VIP लेवल तक पहुंचकर हर हफ्ते बेस रिवार्ड <0>{{money}}</0> पाएं।जमा, सट्टेबाजी और एक्टिव रहने से आप रिवार्ड का गुणक बढ़ा सकते हैं।',
        t03: 'VIP विदड्रॉल',
        p3: 'VIP लेवल <0>{{level}}</0> पर, प्रति विदड्रॉल अधिकतम राशि <0>{{money}}</0> होती है।',
        t04: 'VIP विदड्रॉल आवृत्ति',
        p4: 'VIP लेवल <0>{{level}}</0> पर, आप रोजाना अधिकतम <0>{{count}}</0> बार विदड्रॉल कर सकते हैं।',
        t05: 'VIP विदड्रॉल फीस',
        p5: 'VIP लेवल <0>{{level}}</0> पर, हर ट्रांजैक्शन पर विदड्रॉल फीस केवल <0>{{money}}</0> तक कम होती है।',
      },
      remainTime: 'वीकली कार्ड की बची हुई अवधि:',
      upgrade: {
        to: 'हमारे सम्मानित वीआईपी के लिए:',
        subtitle:
          'आपका लगातार साथ हमें आगे बढ़ने की ताकत देता है!इस नए सिस्टम अपग्रेड के साथ, अब आप पाएंगे:',
        li1: 'और भी बेहतर एक्सक्लूसिव सर्विसेज',
        li2: 'नए और शानदार वीआईपी फीचर्स',
        li3: 'आपके सहयोग के लिए धन्यवाद के तौर पर, हम आपको एक स्पेशल अपग्रेड गिफ्ट पैकेज दे रहे हैं!',
      },
      weekCardReward: {
        title: 'वीकली कार्ड रिवार्ड्स',
        p1: 'वीकली कार्ड रिवार्ड्स: जब आपके पास वीकली कार्ड एक्टिव रहता है, उस दौरान रिवार्ड्स जमा होते हैं।',
        p2: '(नोट: इन्हें पाने के लिए आपको हर दिन लॉग इन करना ज़रूरी है। जो दिन छूट जाते हैं, उनके लिए रिवार्ड नहीं मिलेगा।)',
      },
      weekCard: {
        p1: 'अभी रिचार्ज करें और तुरंत <0>{{money}}</0> पाए',
        p2: 'अतिरिक्त दैनिक बोनस पाए:',
        p3: 'कुल प्राप्त वैल्य: <0>{{money}}</0>',
      },
      weekReward: {
        title: '<0>साप्ताहिक VIP रिवार्ड</0>',
        t1: 'ये रहे आपके साप्ताहिक VIP रिवार्ड्स',
        t2: 'अपने रिवार्ड्स कैसे बढ़ाएं ?',
        p1: 'वीआईपी रिवार्ड्स आपके पिछले हफ्ते की ऐप एक्टिविटी पर निर्भर करते हैं। डिपॉजिट, बेटिंग और एंगेजमेंट से आपका मल्टीप्लायर बढ़ता है।',
        p2: 'हर यूज़र के पास <0>{{money}}</0> से ज्यादा रिवार्ड्स कमाने का मौका होता है!',
        yourReward: 'आपका पिछला हफ्ते का रिवार्ड',
      },
      weeklyRemain: 'आपका साप्ताहिक कार्ड शेष',
      confirmBuyTitle: 'साप्ताहिक कार्ड खरीदें',
      confirmBuy: '{{type}} साप्ताहिक कार्ड खरीदने की पुष्टि करें?',
      weekCardBuySuccess: '{{type}} साप्ताहिक कार्ड सफलतापूर्वक खरीदें',
      noVip:
        'साप्ताहिक कार्ड केवल वीआईपी उपयोगकर्ताओं को खरीदने का समर्थन करता है, कृपया अपग्रेड करें',
    },
    rules: {
      title: 'VIP वीकली कार्ड इस्तेमाल के नियम',
      subtitle1: 'VIP वीकली पास क्या है?',
      sub1paragraph1:
        'एक्सक्लूसिव सुविधा — यह सिर्फ VIP यूज़र्स के लिए है और खरीदते ही एक्टिव हो जाता है।',
      sub1paragraph2:
        ' वैधता अवधि:हर वीकली कार्ड 7 कैलेंडर दिनों तक वैध रहता है (जरूरत पड़ने पर इसे बढ़ाया भी जा सकता है)।',
      subtitle2: ' डबल रिवार्ड',
      sub2paragraph1:
        'जितना रीचार्ज करें, उतना ही वैल्यू का रिवार्ड पाएं।(जैसे: 30 युआन रीचार्ज करने पर 30 पॉइंट्स मिलेंगे)',
      sub2paragraph2:
        'वैधता अवधि: प्रत्येक साप्ताहिक कार्ड 7 प्राकृतिक दिनों तक चलता है (बढ़ाया जा सकता है)',
      subtitle3: ' रिवार्ड कलेक्शन',
      sub3paragraph1:
        'हर हफ्ते के दौरान मिलने वाले रिवार्ड्स को समय रहते कलेक्ट करें।',
      sub3paragraph2:
        'समाप्ति के बाद कोई रिडेम्प्शन नहीं: साप्ताहिक कार्ड की समाप्ति के बाद जिन पुरस्कारों का दावा नहीं किया जाता है, वे अमान्य होंगे',
      subtitle4: 'ओवरले विशेषाधिकार',
      sub4paragraph1:
        'एक ही प्रकार का साप्ताहिक पास: वैधता अवधि बढ़ाने के लिए एकाधिक पास खरीदें (उदाहरण के लिए 2 खरीदें = 14 दिन)',
      sub4paragraph2:
        'कई प्रकार के साप्ताहिक कार्ड: 3 प्रकार के साप्ताहिक कार्ड एक ही समय में सक्रिय किए जा सकते हैं, और पुरस्कार एक साथ दिए जाते हैं।',
      sub4example:
        '(उदाहरण: पहले दिन कार्ड A खरीदें, दूसरे दिन कार्ड B खरीदें → दूसरे दिन से A+B दोनों पुरस्कारों का आनंद लें)',
      subtitle5: 'वीआईपी एक्सक्लूसिव',
      sub5paragraph1:
        'केवल वीआईपी उपयोगकर्ता ही इस उत्पाद को देख/खरीद सकते हैं, गैर-वीआईपी उपयोगकर्ता इसका उपयोग नहीं कर सकते',
      sub5paragraph2:
        'सोमवार को [गोल्डन वीक कार्ड] खरीदें → अगले सोमवार तक हर दिन गोल्ड रिवॉर्ड पाएँ',
      sub5paragraph3:
        'शुक्रवार को वही वस्तु पुनः खरीदें → वैधता अवधि अगले रविवार तक बढ़ा दी गई है और पुरस्कार का दावा अभी भी किया जा सकता है',
      sub5remark1:
        'पुरस्कारों का दावा करने और साप्ताहिक कार्ड के लाभों को अधिकतम करने के लिए दैनिक लॉग इन करने की सिफारिश की जाती है!',
      sub5remark2:
        'यदि आपके कोई प्रश्न हों तो कृपया ग्राहक सेवा से संपर्क करें',
    },
    success: 'सफलतापूर्वक प्राप्त हुआ',
    rechargeTip:
      '{{level}} स्तर तक पहुँचने के लिए <0>{{price}}</0> अधिक रिचार्ज करें',
    incoming: 'इस स्तर तक पहुँचने के बाद, छिपा हुआ स्तर अनलॉक हो जाता है',
  },
  referral: {
    copy: 'कॉपी करें',
    invite: 'इनवाइट करें',
    copied: 'सफलतापूर्वक कॉपी किया गया',
  },
  luckyspin: {
    add: 'जोड़ें',
    spin: 'स्पिन',
    won: 'जीत',
    winner: 'बड़े विजेता',
    mySpin: 'मेरी स्पिन',
    free: 'फ्री',
    myfree: 'मेरा फ्री',
    morefree: 'और फ्री',
    vip: 'वीआईपी',
    usefreefirst: 'कृपया पहले फ्री वाले का उपयोग करें',
  },
  'error-pages': {
    refresh: {
      label: {
        title: 'कुछ गलती हुई है!',
        'sub-title': 'कृपया पेज को रीफ्रेश करें',
        'try-again': 'फिर कोशिश करें',
      },
    },
    'कोई डेटा नहीं': {
      label: {
        title: 'कोई डेटा नहीं',
      },
    },
    'नहीं मिला': {
      label: {
        title: 'वर्तमान नेटवर्क सिग्नल खराब है',
        'sub-title': 'कृपया नेटवर्क की जांच करें',
      },
    },
    'कोई रिजल्ट नहीं': {
      label: {
        title: 'कोई रिजल्ट नहीं मिला!',
      },
    },
  },
  share: {
    copy: 'कॉपी',
    invite: 'इनवाइट करें',
    'copy-success': 'सफलतापूर्वक कॉपी किया गया',
    copied: 'सफलतापूर्वक कॉपी किया गया',
  },
  casino: {
    big: 'बड़ी',
    win: 'जीत',
    detail: {
      title: 'भाग्यशाली खिलाड़ियों को बधाई',
    },
    winPrize: 'जीत का प्राइज',
    playnow: 'अभी खेलें',
  },
  login: {
    label: {
      login: 'लॉग इन',
      skip: 'छोड़ें',
      sign: 'साइन अप करें',
      next: 'अगला',
      'select-region': 'क्षेत्र चुनें',
      'otp-login': 'ओटीपी लॉगिन',
      'password-login': 'पासवर्ड लॉगिन',
      'get-otp': 'ओटीपी प्राप्त करें',
      'set-password': 'पासवर्ड सेट करें',
    },
    tip: {
      'no-phone': 'फ़ोन नंबर दर्ज करें',
      'no-password': 'पासवर्ड डालें',
      'no-otp': 'ओटीपी दर्ज करें',
      phone: 'फ़ोन नंबर दर्ज करें',
      password: 'पासवर्ड डालें(6-18)',
      passwordRule:
        'पासवर्ड 8 से 16 कैरेक्टर में होना चाहिए और इसमें अंक और अक्षर दोनों होने चाहिए',
      'पासवर्ड कंफर्म करें': 'पासवर्ड कंफर्म करें',
      forgot: 'पासवर्ड भूल गए?',
      'new-account': 'अकाउंट की ज़रूरत है?',
      'sing-in': 'साइन अप करें',
      otp: 'ओटीपी डालें',
      'referral-code': 'रेफर कोड',
      confrim18: 'हाँ मेरी उम्र 18 वर्ष से अधिक है',
      'allow-notify':
        'हमें इस मोबाइल नंबर के माध्यम से आपको जीत की जानकारी देने की अनुमति दें।',
      'has-account': 'पहले से रजिस्टर्ड है?',
      'sign-in': 'लॉगिन',
      page18: 'हाँ मेरी उम्र 18 वर्ष से अधिक है',
      notify:
        'हमें इस मोबाइल नंबर के माध्यम से आपको जीत की जानकारी देने की अनुमति दें।',
      'pwd-dif': 'दोनों पासवर्ड समान नहीं है',
      modified: 'पासवर्ड सफलतापूर्वक बदल दिया गया. कृपया फिर से लॉगिन करें',
      'game-not-active':
        'माफ़ कीजिये, गेम अभी मेंटेनेंस में है। कृपया बाद में पुन: प्रयास करें।',
    },
  },
  paidSuccess: {
    label: {
      title: 'पेमेंट',
      subTitle: 'सफलतापूर्वक पे कर दिया गया',
      viewOrder: 'आर्डर देखें',
      backHome: 'होम पर जाएं',
    },
    tip: {
      msg: 'आपकी टिकटें सफलतापूर्वक खरीद ली गई हैं। कृपया ड्रा के समय का ध्यान रखें और रिजल्ट की जांच करें।',
    },
  },
  splash: {
    tip: {
      checkingResources: 'संसाधनों की जाँच हो रही है...',
      checkingVersion: 'वर्ज़न की जाँच हो रही है...',
      downloading: 'संसाधनों को डाउनलोड किया जा रहा है...',
      resolve:
        'संसाधन समायोजित किये जा रहे हैं (इसके दौरान आपका इंटरनेट डेटा खर्च नहीं होगा)',
      alertTitle: 'अपडेट उपलब्ध है',
      restart: 'रीस्टार्ट करें',
      alertContent:
        'अपडेट उपलब्ध है। अपडेट लागू करने के लिए ऐप को रीस्टार्ट किया जा रहा है...',
    },
  },
  recharge: {
    tip: {
      easyPaymentError: 'असफल हुआ, कृपया कोई अन्य भुगतान विधि चयन करें',
    },
  },
  'recharge-page': {
    currentMethod: 'वर्तमान विधि',
    label: {
      records: 'रिकॉर्ड्स',
      min: 'मिनिमम',
      max: 'अधिकतम',
      channel: 'रिचार्ज चैनल',
      enter: 'रिचार्ज राशि दर्ज करें',
    },
    tip: {
      payMethodTip:
        'कृपया वर्तमान विधि असफल होने पर दूसरे विधि में स्विच करें।',
      'money-error': 'कृपया सही राशि दर्ज करें',
      'paymethod-error': 'कृपया भुगतान विधि का चयन करें',
    },
  },
  datePicker: {
    label: {
      select: 'तारीख चुनें',
    },
  },
  rebate: {
    tabs: {
      all: 'सभी',
      finish: 'पूरा करने के लिए',
      collect: 'कलेक्ट करने के लिए',
      received: 'प्राप्त हुआ',
    },
    title: 'कैशबैक',
    filter: 'फ़िल्टर',
    undone: 'अपूर्ण',
    unclaimed: 'अनदेखा',
    completed: 'पूर्ण हुआ',
    unfinished: 'अपूर्ण',
    receive: 'प्राप्त करें',
    received: 'प्राप्त हुआ',
    today: 'आज',
    yesterday: 'बीता हुआ कल',
    betting: 'अनुमानित बेटिंग：',
    rebate: 'अनुमानित कैशबैक：',
    congratulations: 'बधाई हो！',
    'get-bonus': 'बोनस प्राप्त करें',
    rule: {
      betting: 'बेटिंग बोनस:',
      'betting-detail':
        '{{name}} प्लेयर को बेटिंग अमाउंट के अनुसार कैशबैक मिलेगा। जितना अधिक आप बेट करेंगे, उतना ही आपको कैशबैक मिलेगा।',
      activity: 'गतिविधि विवरण:',
      'activity-detail':
        '{{name}} सुपर बोनस कैशबैक सुविधा आपके लिए ओपन है। अब कोई फर्क नहीं पड़ता कि आप जीतते हैं या हारते हैं, आपको रोजाना बोनस मिलेगा।',
      actrule: 'गतिविधि नियम:',
      'actrule-detail':
        'खिलाड़ी प्रतिदिन एक बेटिंग कैशबैक बोनस क्लैम कर सकते हैं। बोनस क्लैम करने का समय हर दिन 12:30AM के बाद है.',
      precaution: 'सावधानियां:',
      'precaution-detail-1':
        '-केवल योग्य {{name}} मेंबर इन एक्टिविटी में भाग ले सकते हैं। प्रत्येक सदस्य को रिबेट बोनस का दावा करने के लिए सिंगम अकाउंट में, अकाउंट डिटेल डालना होगा। - किसी भी उपयोगकर्ता जो गैरकानूनी गतिविधियों में शामिल है, उसे सख्ती से निकाल दिया जाएगा',
      'precaution-detail-2':
        '- एक ही फ़ोन नंबर, बैंक खाता नंबर, ईमेल और आईपी एड्रेस को कई अकाउंट के लिए उपयोग नहीं किया जा सकता है',
      'precaution-detail-3':
        '- {{name}} को खातों को फ़्रीज़ करने या भुगतान रद्द करने का पूरा अधिकार है यदि उपयोगकर्ता या ग्रुप द्वारा बोनस का लाभ उठाने के लिए गैरकानूनी गतिविधि की जाती है तो। (अंतिम बोनस निर्णय सिंगम का है)',
    },
  },
  wallet: {
    title: 'मेरा वॉलेट',
    total: 'कुल वॉलेट',
    recharge: 'रिचार्ज',
    main: 'मेन वॉलेट',
    third: 'थर्ड पार्टी वॉलेट',
    transfer: 'मेन वॉलेट ट्रांसफर',
    translation: 'ट्रांसलेशन: 5 सेकंड',
    transComplete: 'परिवर्तन पूर्ण हुआ',
    transferNav: {
      recharge: 'रिचार्ज',
      withdraw: 'विड्राल',
      transfer: 'ट्रांसफर',
    },
  },
  promotion: {
    title: 'प्रमोशन',
    go: 'जाएँ',
    playNow: 'अभी खेलें',
    view: 'देखें',
    detail: 'गतिविधि विवरण',
    join: 'शामिल हों',
    checkin: 'चेक इन',
    checkinDescription: 'प्रतिदिन चेक इन करके बहुत सारे पुरस्कार प्राप्त करें',
  },
  satta: {
    title: {
      betting: 'बेटिंग',
      rule: 'नियम',
      history: 'रिजल्ट हिस्ट्री',
      order: 'मेरे ऑर्डर',
      panel: 'पेनल: ',
      open: 'ओपन',
      close: 'क्लोज',
    },
    betting: {
      ank: 'अंक',
      jodi: 'जोड़ी',
      sp: 'SP',
      dp: 'DP',
      tp: 'TP',
      half: 'हाफ संगम',
      full: 'फुल संगम',
      exwinning: 'प्रत्याशित जीत:',
      open: 'ओपन',
      close: 'क्लोज',
      paynow: 'भुगतान करें',
      add: 'जोड़ें',
      mybids: 'मेरी बिड्स',
      bids: 'बिड्स',
      tip: {
        enter: {
          amount: 'अमाउंट दर्ज करें',
          open: 'ओपन डिजिट दर्ज करें',
          opens: 'ओपन डिजिट्स दर्ज करें',
          close: 'क्लोज डिजिट दर्ज करें',
          closes: 'क्लोज डिजिट्स दर्ज करें',
          jodi: 'जोड़ी डिजिट्स दर्ज करें',
          openpanna: 'ओपन पन्ना दर्ज करें',
          closepanna: 'क्लोज पन्ना दर्ज करें',
        },
        require: {
          amount: 'अमाउंट दर्ज करें',
          open: 'ओपन डिजिट दर्ज करें',
          opens: 'ओपन डिजिट्स दर्ज करें',
          close: 'क्लोज डिजिट दर्ज करें',
          closes: 'क्लोज डिजिट्स दर्ज करें',
          jodi: 'जोड़ी डिजिट्स दर्ज करें',
          openpanna: 'ओपन पन्ना दर्ज करें',
          closepanna: 'क्लोज पन्ना दर्ज करें',
        },
        check: 'कृपया पूरे नंबर लिखें',
        minAmount: 'न्यूनतम भुगतान अमाउंट {{amount}} है',
      },
      digitTitle: {
        ank: 'सिंगल डिजिट:',
        jodi: 'जोड़ी डिजिट्स:',
        sp: 'सिंगल पन्ना:',
        dp: 'डबल पन्ना:',
        tp: 'ट्रिपल पन्ना:',
        half: 'HS:',
        full: 'FS:',
      },
      describe: {
        ank: 'ओपन या क्लोज पर क्लिक करें, और इनपुट बॉक्स में जो आप चाहते हैं उस अंक को दर्ज करें, जैसे कि 1',
        jodi: 'दो-अंकीय संख्या (जोड़ी) दर्ज करें जो आप लगाना चाहते हैं, जैसे कि 12',
        sp: 'ओपन या क्लोज पर क्लिक करें, और इनपुट बॉक्स में तीन अंक दर्ज करें, जैसे कि 123',
        dp: 'ओपन या क्लोज पर क्लिक करें, और तीन अंक दर्ज करें, जिनमें दो डिजिट एक जैसे होने चाहिए, जैसे कि 112',
        tp: 'ओपन या क्लोज पर क्लिक करें, और तीन समान अंक दर्ज करें, जैसे कि 111',
        half: 'ओपन या क्लोज पर क्लिक करें, और इनपुट बॉक्स में तीन अंक का पन्ना और सिंगल अंक दर्ज करें, जैसे कि 123 और 7 (ओपन पर क्लिक करने पर क्लोज का सिंगल अंक लगेगा और क्लोज पर क्लिक करने पर ओपन का अंक लगेगा)',
        full: 'दो इनपुट बॉक्स में तीन अंक दर्ज करें, जैसे कि 123 और 123',
      },
    },
  },
};
